import database from '../../model/firebase/firebase';

export const usersTypes = {
  FETCH_USERS_DATA: 'users/GETTING_DATA',
  ACCEPT_USER: 'users/UPDATE_DATA',
};

export const setUsers = (users) => ({
  type: usersTypes.FETCH_USERS_DATA,
  users,
});

export const acceptUser = (newValues) => ({
  type: usersTypes.ACCEPT_USER,
  newValues,
});

export const startShowUsers = () => async (dispatch, getState) => {
  const { platform } = getState();
  const users = (await database.collection(`${platform.platformName}/data/users`).get()).docs.map((user) => ({
    ...user.data(),
    docID: user.id,
    id: user.id
  }));
  dispatch(setUsers(users));
};
